// import agriImg from "../../img/Service-Product/Agriculture-spraying.png";

export const services = [
  "Agriculture Spraying",
  "Disaster Management",
  "Fire Fighting and Solar Panel Cleaning",
  "Pilot Training",
  "Drone Repair And Maintenance",
  // "UAV Consultancy",
];

export const products = [
  "Thea Agriculture Drone 16 Litres",
  "Thea Agriculture Drone 10 Litres",
  "Naina Disaster Management Drone",  
];
export const events = [
  "KRISHI MAHOTSAV, NAVSARI",
  "ST. JOHN COLLEGE, PALGHAR",
  "13th NATIONAL SEED CONGRESS, VARANASI",
  "KRISHI NIDESHALAY DEHRADUN, UTTARAKHAND",
  "NAGAR NIGAM LUCKNOW, U.P",
  "VAGHAI NAVSARI AGRICULTURAL UNIVERSITY, GUJARAT",
  "UP INTERNATIONAL TRADE SHOW, NOIDA",
  "BHARAT DRONE SHAKTI, GHAZIABAD",
  "BAGHPATH KISAN MELA",
  "VIBRANT GUJARAT, GIFT CITY",
  ];
const AgriBreadProp = {
  title: "Agriculture Spraying",
  text: "Welcome to Vama Skylight, where cutting-edge technology meets agriculture to revolutionize crop management.",
  arr: ["Home", "Services", "Agriculture Spraying"],
};

const agriSprayPts = [
  "Our drones are equipped with advanced sensors and GPS technology to ensure precise and efficient spraying",
  "Vama Skylight offers tailor-made solutions, considering your crop type, field size, and specific needs",
  "By using drones, we reduce the need for traditional, larger machinery, minimizing soil compaction and environmental impact.",
  "Gain valuable insights into your crop health and performance using our drones.",
];

export const agricultureSprayingProp = {
  breadProp: AgriBreadProp,
  //   img: { agriImg },
  // img: "https://i.ibb.co/6NyYwdH/Agriculture-spraying.png",
  img: `spraying.webp`,
  title: "Agricultural Spraying Services at Vama Skylight",
  text1:
    "Welcome to Vama Skylight, where cutting-edge technology meets agriculture to revolutionize crop management. Our drone-based agricultural spraying services are designed to optimize your farm's productivity while minimizing environmental impact. We pride ourselves on being at the forefront of innovation in the agricultural sector.",
  pointArr: agriSprayPts,
  text2:
    "With a team of experienced drone pilots, agronomists, and technology enthusiasts, we bring you a state-of-the-art solution for precision crop spraying.Our drone fleet is equipped to handle a variety of crops, providing targeted spraying for pest control, fertilization, and disease management.",
  img2: "https://images.unsplash.com/photo-1523678631214-6532a89c96cc?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTE0fHxkcm9uZXxlbnwwfHwwfHx8MA%3D%3D",
  img3: "https://images.unsplash.com/photo-1533487924410-8792b4f3a661?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  isService: true,
};
// const landSurveyBreadProp = {


const disasterBreadProp = {
  title: "Disaster Management",
  text: "VAMA Skylight Resilience: Empowering Disaster Management through Drone Technology",
  arr: ["Home", "Services", "Disaster Management"],
};
const disasterPts = [
  "Our drone fleet enables quick deployment to disaster-stricken areas, facilitating rapid and accurate assessment",
  "Obtain real-time data to make informed decisions during critical phases of disaster response.",
  "VAMA Skylight Resilience supports search and rescue operations by providing aerial views of affected areas, enhancing the efficiency of first responders",
  "Our drones capture high-resolution imagery to assess and document the extent of damage caused by disasters",
];
export const disasterManagementProp = {
  breadProp: disasterBreadProp,
  // img: "https://i.ibb.co/0c5xPz9/Disaster-Management.png",
  img: `Disaster_Management.jpg`,
  title: "Disaster Management Services at Vama Skylight",
  text1:
    "Welcome to VAMA Skylight Resilience, where innovation meets preparedness. Explore our comprehensive disaster management services, leveraging cutting-edge drone technology to enhance response, recovery, and resilience in the face of unforeseen challenges.",
  pointArr: disasterPts,
  text2:
    "In disaster-stricken areas with compromised communication infrastructure, our drones act as mobile communication hubs, facilitating coordination and information exchange among response teams.",
  img2: "https://images.unsplash.com/photo-1523678631214-6532a89c96cc?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTE0fHxkcm9uZXxlbnwwfHwwfHx8MA%3D%3D",
  img3: "https://images.unsplash.com/photo-1533487924410-8792b4f3a661?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  isService: true,
};

const fireFightingBreadProp = {
  title: "Fire Fighting and Solar Panel Cleaning ",
  text: "VAMA Skylight:Revolutionizing Emergency Response with Drone Innovation.",
  arr: ["Home", "Services", "Fire Fighting and Solar Panel Cleaning"],
};
const fireFightingPts = [
"Robust hexacopter design ensures stability and durability in demanding conditions.",
"Advanced high-pressure spraying system delivers water or fire retardant directly to the fire source.",
"Minimizes structural damage and increases operational efficiency during critical situations.",
"Equipped for solar panel cleaning, providing effective maintenance of solar installations.",
"Versatile dual-purpose functionality for firefighting and solar panel maintenance.",
];
export const fireFightingProp = {
  breadProp: fireFightingBreadProp,
  // img: "https://i.ibb.co/0c5xPz9/Disaster-Management.png",
  img: `firefighting.jpg`,
  title: "Solar Panel Cleaning Operations by VAMA Skylight",
  text1:
  "The Fire Fighting Drone is a robust and intelligent hexacopter engineered for rapid, precise, and efficient aerial fire suppression. Designed to operate in high-risk environments, it delivers high-pressure water or fire-retardant solutions directly to the source, minimizing structural damage and maximizing operational efficiency during critical emergencies.",
  pointArr: fireFightingPts,
  text2:
  "In addition to its fire response capabilities, this versatile drone is also equipped for high-altitude cleaning tasks such as solar panel maintenance, high-rise cleaning tasks, and facade washing. Its high-pressure spraying system effectively removes dust, debris, and stains from hard-to-reach surfaces, enhancing efficiency and safety. This multi-purpose functionality makes it ideal for modern infrastructure and clean energy maintenance. ",
  img2: "https://images.unsplash.com/photo-1523678631214-6532a89c96cc?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTE0fHxkcm9uZXxlbnwwfHwwfHx8MA%3D%3D",
  img3: "https://images.unsplash.com/photo-1533487924410-8792b4f3a661?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  isService: true,
}
const pilotBreadProp = {
  title: "Pilot Training",
  text: "Welcome to VAMA Skylight, your gateway to becoming a skilled and certified drone pilot",
  arr: ["Home", "Services", "Pilot Training"],
};
const pilotsPts = [
  " Ideal for beginners, covering essential skills, regulations, and safety measures.",
  "Specialized training for industry-specific applications, including agriculture, mapping, surveillance, and disaster management",
  "Hone your skills in a controlled environment with our state-of-the-art flight simulation programs.",
  "Get behind the controls of industry-standard drones during our hands-on training sessions.",
];
export const pilotTrainingProp = {
  breadProp: pilotBreadProp,
  // img: "https://i.ibb.co/pKZXkQg/Pilot-Training.png",
  img: `Traning.webp`,
  title: "Pilot Training Services at Vama Skylight",
  text1:
    "With experienced instructors and state-of-the-art training facilities, we provide a structured and hands-on learning experience to prepare you for a successful career in drone piloting",
  pointArr: pilotsPts,
  text2:
    "Explore our comprehensive training programs designed to equip you with the knowledge and expertise needed to navigate the skies with confidence and precision",
  img2: "https://images.unsplash.com/photo-1523678631214-6532a89c96cc?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTE0fHxkcm9uZXxlbnwwfHwwfHx8MA%3D%3D",
  img3: "https://images.unsplash.com/photo-1533487924410-8792b4f3a661?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  isService: true,
};
const repairBreadProp = {
  title: "Drone Repair And Maintenance",
  text: "Welcome to VAMA Skylight, your gateway to becoming a skilled and certified drone pilot",
  arr: ["Home", "Services", "Drone Repair And Maintenance"],
};
const repairPts = [
  " Ideal for beginners, covering essential skills, regulations, and safety measures.",
  "Specialized training for industry-specific applications, including agriculture, mapping, surveillance, and disaster management",
  "Hone your skills in a controlled environment with our state-of-the-art flight simulation programs.",
  "Get behind the controls of industry-standard drones during our hands-on training sessions.",
];
export const repairProp = {
  breadProp: repairBreadProp,
  // img: "https://i.ibb.co/pKZXkQg/Pilot-Training.png",
  img: `drone-repair.jpg`,
  title: "Drone Repair And Maintenance at Vama Skylight",
  text1:
    "With experienced instructors and state-of-the-art training facilities, we provide a structured and hands-on learning experience to prepare you for a successful career in drone piloting",
  pointArr: repairPts,
  text2:
    "Explore our comprehensive training programs designed to equip you with the knowledge and expertise needed to navigate the skies with confidence and precision",
  img2: "https://images.unsplash.com/photo-1523678631214-6532a89c96cc?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTE0fHxkcm9uZXxlbnwwfHwwfHx8MA%3D%3D",
  img3: "https://images.unsplash.com/photo-1533487924410-8792b4f3a661?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  isService: true,
};
// const uavBreadProp = {

const th16BreadProp = {
  title: "Thea Agriculture Drone 16 Litres",
  text: "Welcome to the future of precision agriculture with Thea Agriculture Drone TH16L",
  arr: ["Home", "Products", "Thea Agriculture Drone 16 Litres"],
};
const th16Pts = [
  "Structure: Hexacopter Structure, FOS = 3",
  "Foldable Size: 990 mm x 1120 mm x 630 mm",
  "Flight Mode: Fully Autonomous, Loiter Mode",
  "Liquid Tank:16-liter tank capacity",
  "Battery Fly Time: Up to 20 minutes with payload.",
  "Return to Launch (RTL): Triggers for Empty Tank, Battery Drained, Mission Complete, Geofence Breached.",
  "Live Video Streaming on GCS: 2 MP HD camera with high lumens LED lights for low-light navigation",
  "Nozzles: 6x TeeJet High Pressure Flat Spray Brass Sprayer with Carbon Fiber Body",
  "RADAR-based Collision Avoidance: Detects obstacles in both front and rear directions, reroutes path",
  "RADAR-based Terrain Following: Maintains constant spray height up to 10 meters, detects variable crop heights.",
  "Maximum Height: 92 meters (300 feet) above ground level.",
  "Battery capacity: 2x 22000 mAh (6S) LiPo 25C.",
  "DGCA Approved Model: Yes.",
 <b>TH16L Price = Rs.7,50,000/. (Term and Conditions Apply) </b>
];
export const th_agri_16 = {
  breadProp: th16BreadProp,

  img: `TH16L.jpg`,
  title:
    "Thea Agriculture Drone 16L: Precision Spraying for Sustainable Farming",
  text1:
    "Unleash the power of cutting-edge technology to transform your farming practices and maximize crop yield. The TH16L is a medium-category hexacopter drone designed specifically for efficient and precise plant protection chemical spraying.",
  pointArr: th16Pts,
  text2: "",
  img2: "tc.jpg",
  img3: "",
  pdf1: "Manual.pdf",
  isService: false,
};
const th10BreadProp = {
  title: "Thea Agriculture Drone 10 Litres",
  text: "Thea Agriculture Drone TH10L: Precision Farming Redefined",
  arr: ["Home", "Products", "Thea Agriculture Drone 10 Litres"],
};
const th10Pts = [
  "10-liter tank capacity",
  "Up to 25 minutes of flight time.",
  "Up to 2.5-acre spraying capacity on a single charge.",
  "6-teeject carbon fibre high-precision sprayer with swath 3-5m.",
  "Spraying level adjustment facility.",
  "Terrain following capability.",
  "Anti-collision object avoidance with built-in radar",
  "Collision safety and auto height adjustment facility with terrain radar.",
  "Autonomous flying mission and spraying capability.",
  "Voice alarm-enabled Ground Control System (GCS).",
  "Real-time FPV camera with 720p video feed.",
  "High-precision take-off and landing facility.",
  "Return to land facility in case of any failure.",
];
export const th_agri_10 = {
  breadProp: th10BreadProp,
  // img: "https://i.ibb.co/WpRg48K/10L.png",
  img: `10L.jpeg`,
  title:
    "Thea Agriculture Drone 10L: Precision Spraying for Sustainable Farming",
  text1:
    "Transform your farming practices with Thea Agriculture Drone TH10L, a symbol of precision, reliability, and innovation in the field of agricultural drones. Experience the future of farming today.",
  pointArr: th10Pts,
  text2: "",
  img2: "10L.png",
  img3: "",
  isService: false,
};
const nainaBreadProp = {
  title: "Naina Disaster Management Drone",
  text: "Naina Disaster Management Drone: Precision, Power, and Preparedness",
  arr: ["Home", "Products", "Naina Disaster Management Drone"],
};
const nainaPts = [
  "AI Target Locking and Tracking Mechanism",
  "Featuring four deploying drop mechanisms capable of carrying up to 500 grams each, the drone can deliver essential supplies with a total capacity of up to 2 kilograms.",
  "Equipped with a high-lumen light, the Naina drone ensures visibility in low-light or dark conditions, facilitating efficient search and rescue missions.",
  "The drone features live audio announcing capabilities, enabling specific instructions or warnings to be broadcasted in real-time during disaster scenarios.",
  "Long-Range Capability",
  "The drone boasts an impressive emergency kit lifting capacity of up to 10 kg with a pulley mechanism",
];
export const Naina = {
  breadProp: nainaBreadProp,
  // img: "https://i.ibb.co/0c5xPz9/Disaster-Management.png",
  img: `naina.jpeg`,
  title: "Naina Disaster Management Drone",
  text1:
    "Welcome to the forefront of disaster management technology with the 'NAINA' Disaster Management Search and Rescue Drone. Engineered to respond with precision and efficiency in times of crisis, the Naina drone is your ultimate ally in disaster management scenarios.",
  pointArr: nainaPts,
  text2: "",
  img2: "naina2.jpeg",
  img3: "",
  isService: false,
};
// const surveyBreadProp = {
//   title: "Survey Drone",
//   text: "Welcome to the future of security and surveillance with Guardian Surveillance Drones",
//   arr: ["Home", "Products", "Surveillance Drone"],
// };
// const surveyPts = [
//   "AI-Enhanced Survey Capabilities",
//   "High-Resolution Camera Systems",
//   "Long-Range Flight Capability",
//   "Real-Time Streaming and Recording",
//   "Auto-Pilot Navigation",
//   "Customizable Surveillance Plans",
// ];
// export const surveyProp = {
//   breadProp: surveyBreadProp,

//   img: `Land-Surveillance.png`,
//   title: "Survey Drone",
//   text1:
//     "Our cutting-edge drones are engineered to redefine the landscape of surveillance, providing advanced technology for comprehensive monitoring and protection.",
//   pointArr: surveyPts,
//   text2: "",
//   img2: "https://images.unsplash.com/photo-1523678631214-6532a89c96cc?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTE0fHxkcm9uZXxlbnwwfHwwfHx8MA%3D%3D",
//   img3: "https://images.unsplash.com/photo-1533487924410-8792b4f3a661?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//   isService: false,
// };

export const galleryImages = [
  {
    img: "1.jpg",
  },
  {
    img: "2.jpg",
  },
  {
    img: "3.jpg",
  },
  {
    img: "4.jpg",
  },
  {
    img: "5.jpg",
  },
  {
    img: "6.jpg",
  },

  // {
  //   img: "7.jpg",
  // },

  // {
  //   img: "8.jpg",
  // },
];
export const legalImage = [
  {
    img: "1.jpg",
  },
  {
    img: "2.jpg",
  },
  {
    img: "3.jpg",
  },
  {
    img: "4.jpg",
  },
  {
    img: "5.jpg",
  },
  {
    img: "6.jpg",
  },

  // {
  //   img: "7.jpg",
  // },

  // {
  //   img: "8.jpg",
  // },
];
const krishimahotsavBreadProp = {
  title: "KRISHI MAHOTSAV, NAVSARI",
  text: "Drone Express Flagged Off at Krishi Mahotsav 2024,Navsari",
  arr: ["Home", "Articles And Events", "Krishi Mahotsav, Navsari"],
};
export const krishimahotsavProps = {
  breadProp: krishimahotsavBreadProp,
  title: "Drone Express Flagged Off at Krishi Mahotsav 2024",
  text1:
    "On 21st December 2024, at the prestigious Krishi Mahotsav 2024 held at Navsari Agricultural University, Gujarat's Hon'ble Agriculture Minister Shri Raghavji Bhai Patel (@RaghavjiPatel), along with Vice-Chancellor Shri Z.P. Zala (@vc_nau) and representatives from @NAUOfficial, officially flagged off the 'Drone Express' initiative by Vama Skylight LLP.This event marked a significant milestone in advancing precision agriculture through drone technology, addressing critical agricultural challenges such as crop spraying efficiency, real-time field monitoring, and sustainable resource management.",
  img: "krishimela1.jpeg",
  otherImages: [ "krishimela3.jpeg", "krishimela5.jpeg"],
};
const palgharBreadProp = {
  title: "ST. JOHN COLLEGE, PALGHAR",
  text: "Drone Training given to students at St. John College Palghar",
  arr: ["Home", "Articles And Events", "ST. JOHN COLLEGE, PALGHAR"],
};
export const palgharProps = {
  breadProp: palgharBreadProp,
  title: "DRONE LEARNING AT ST. JOHN COLLEGE,PALGHAR ",
  text1:
    "Our team visited St. John College of Engineering and Management, Palghar, to teach students about drone technology also assist in set-up a dedicated drone lab. Our session included hands-on training in drone building and operations, along with a presentation on advancements in drone technology. This initiative highlights our commitment to fostering innovation and empowering the college with cutting-edge resources for drone education.",
  img: "palghar1.jpg",
  otherImages: [ "palgharsir.jpeg", "palghar3.jpeg"],
};

const irriBreadProp = {
  title: "13th NATIONAL SEED CONGRESS, VARANASI",
  text: "13th National Seed Congress (NSC) Details",
  arr: ["Home", "Articles And Events", "13th NATIONAL SEED CONGRESS, VARANASI"],
};
export const irriProps = {
  breadProp: irriBreadProp,
  title: "VAMA SKYLIGHT LLP AT THE 13th NATIONAL SEED CONGRESS (NSC) 2024,VARANASI",
  text1:
    "Vama Skylight LLP participated in the 13th National Seed Congress (NSC) in Varanasi from 28 to 30 November, 2024, which brought together over 700 industry leaders, researchers, and policymakers. Inaugurated by Union Minister Shri Shivraj Singh Chouhan, the event highlighted the need for collaboration and innovation in the seed sector. Our stall was honored with a visit from Shri Dinesh Pratap Singh, Minister of State, underscoring our commitment to advancing agricultural technology.",
  img: "irri1.jpeg",
  otherImages: [ "irri2.jpeg", "irri3.png"],
};

const dehradunBreadProp = {
  title: "KRISHI NIDESHALAY DEHRADUN, UTTARAKHAND",
  text: "Krishi Nideshalay Dehradun Details",
  arr: [
    "Home",
    "Articles And Events",
    "KRISHI NIDESHALAY DEHRADUN, UTTARAKHAND",
  ],
};
export const dehradunProps = {
  breadProp: dehradunBreadProp,
  title: "KRISHI NIDESHALAY DEHRADUN,UTTARAKHAND",
  text1:
    "A Demo in front of Director of Agriculture  K C Pathak, Krishi Nideshalaya  ",
  img: "UK.jpg",
  otherImages: [],
};

const lucknowBreadProp = {
  title: "NAGAR NIGAM LUCKNOW, U.P",
  text: "Nagar Nigam Lucknow Details",
  arr: ["Home", "Articles And Events", "NAGAR NIGAM LUCKNOW, U.P"],
};
export const lucknowProps = {
  breadProp: lucknowBreadProp,
  title: "NAGAR NIGAM LUCKNOW",
  text1:
    "VAMA Skylight's drones are being deployed for spraying operations in the ponds of Lucknow Municipal Corporation..",
  img: "nn0.jpg",
  otherImages: [ "nn4.jpeg", "nn8.jpeg"],
};

const vaghaiBreadProp = {
  title: "VAGHAI NAVSARI AGRICULTURAL UNIVERSITY, GUJARAT",
  text: "Our presentation details at Vaghai University",
  arr: [
    "Home",
    "Articles And Events",
    "VAGHAI NAVSARI AGRICULTURAL UNIVERSITY, GUJARAT",
  ],
};
export const vaghaiProps = {
  breadProp: vaghaiBreadProp,
  title: "VAGHAI NAVSARI AGRICULTURAL UNIVERSITY, GUJARAT",
  text1:
    "We Demonstrated our AGRICULTURE DRONE TH-16L at Waghai agricultural university, Navsari. We educated more than 150 farmers about agricultural drones , its usage and about advanced farming technology.",

  img: "gr-3.jpeg",
  otherImages: ["guj-1.jpeg", "guj-2.jpeg", "gr-4.jpeg"],
};

const noidaBreadProp = {
  title: "UP INTERNATIONAL TRADE SHOW, NOIDA",
  text: "We are at UP International Trade Show",
  arr: ["Home", "Articles And Events", "UP INTERNATIONAL TRADE SHOW, NOIDA"],
};
export const noidaProps = {
  breadProp: noidaBreadProp,
  title: "UP INTERNATIONAL TRADE SHOW, NOIDA",
  text1:
    "UP International Trade Show held at the India Expo Centre & Mart in Noida was inaugurated by both the President of India and the Chief Minister of Uttar Pradesh. The presence of such esteemed dignitaries underscores the importance of the event not only within the state but also at a national level, highlighting its significance in promoting trade, commerce, and economic development.   VAMA SKYLIGHT participation in this event provided valuable exposure and opportunities for growth within the industry and beyond.",
  img: "up-1.jpeg",
  otherImages: ["up-2.jpeg", "up-3.jpeg", "up-4.jpeg"],
};
const saktiBreadProp = {
  title: "BHARAT DRONE SHAKTI, GHAZIABAD",
  text: "Our presentation at Bhatat Drone Shakti at Ghaziabad",
  arr: ["Home", "Articles And Events", "BHARAT DRONE SHAKTI, GHAZIABAD"],
};
export const saktiProps = {
  breadProp: saktiBreadProp,
  title: "BHARAT DRONE SHAKTI, GHAZIABAD",
  text1:
    "Bharat Drone Shakti 2023 at Hindon Air Force Station, Ghaziabad was a significant opportunity for VAMA SKYLIGHT, especially considering the presence of the Defence Minister of India and other Indian Army personnel. Demonstrating the Naina Drone, which was the highlight of the event,  showcased VAMA SKYLIGHT innovation and expertise in drone technology. Being associated with such a high-profile exhibition  have raised VAMA SKYLIGHT's profile within the defence and technology sectors.Bharat Drone Shakti 2023 was a grand success for VAMA SKYLIGHT. These kinds of events not only provide a platform for showcasing products but also offer invaluable opportunities for networking, collaboration, and future business prospects within the defence industry.",
  img: "sakti-1.jpeg",
  otherImages: ["sakti-2.jpeg", "sakti-3.jpeg", "sakti-4.jpeg"],
};
const bagpatBreadProp = {
  title: "BAGHPATH KISAN MELA",
  text: "We are at Baghpat Kisan Mela showcasing our products",
  arr: ["Home", "Articles And Events", "BAGHPATH KISAN MELA"],
};
export const bagpatProps = {
  breadProp: bagpatBreadProp,
  title: "BAGHPATH KISAN MELA",
  text1: "",

  img: "bag-2.jpeg",
  otherImages: ["bag-1.jpeg", "bag-3.jpeg", "bag-4.jpeg", "bag-5.jpeg"],
};

const giftBreadProp = {
  title: "VIBRANT GUJARAT, GIFT CITY",
  text: "Vibrant Gujrat Event Details",
  arr: ["Home", "Articles And Events", "VIBRANT GUJARAT, GIFT CITY"],
};
export const giftProps = {
  breadProp: giftBreadProp,
  title: "VIBRANT GUJARAT, GIFT CITY",
  text1:
    "Vibrant Gujarat is known for being a significant platform for business networking, investment opportunities, and showcasing innovations in various sectors. Having the event inaugurated by the Prime Minister of India adds a considerable level of importance and visibility to the exhibition. VAMA SKYLIGHT found the event to be interactive, knowledgeable, and successful.",
  img: "gft-3.jpeg",
  otherImages: ["gft-1.jpeg", "gft-2.jpeg", "gft-4.jpeg", "gft-5.jpeg"],
};


